import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/components/shared.module';
import { WidgetWrapperModule } from 'app/views/presentations/widgets/widgetWrapper.module';
import { EmptyWidget, EmptyWidgetComponent } from './empty.widget';

@NgModule({
    imports: [
        TranslateModule,
        WidgetWrapperModule.wrapWidget(EmptyWidget)
    ],
    declarations: [
        EmptyWidgetComponent
    ],
    entryComponents: [
        EmptyWidgetComponent
    ]
})
export class EmptyWidgetModule { }



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/empty/empty.module.ts